import React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import PaginationItem from '@mui/material/PaginationItem';

function VideoListPagination({ videoListCount, paginate, currentPage }) {

    const COUNT_PER_PAGE = 30; // API에 정해져 있는 내용
    const lastPage = Math.ceil(videoListCount / COUNT_PER_PAGE);

    const handlePageChange = (e, page) => {
        paginate(page);
    }

    return (
        <div className='container-pagination'>
            <Stack
                spacing={2}
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
                <Pagination
                    page={currentPage}
                    count={lastPage}
                    defaultPage={1}
                    onChange={handlePageChange}
                    renderItem={(item) => (
                        <PaginationItem
                            {...item}
                            style={{
                                fontWeight: item.page === currentPage ? 'bold' : 'normal',
                                color: item.page === currentPage ? '#888' : '#363636'
                            }}
                        />
                    )}
                />
            </Stack>
        </div>
    );
}

export default VideoListPagination;